import { APPLICATION_NAME, TOOLING_METRICS_ENV } from '../constants';
import { EventMetric } from '../types/event-metrics';

/**
 * Creates a metric event payload with common properties
 * @param label - The event label
 * @param value - The event value
 * @param tags - Tags object to include in the event
 * @returns A metric event payload with common properties
 */
export const createMetricEventPayload = (
  label: EventMetric['label'],
  value: number,
  tags: Record<string, string>
): EventMetric => ({
  label,
  value,
  app_name: APPLICATION_NAME,
  environment: TOOLING_METRICS_ENV,
  tags,
});
